/** Impls dos use cases de Relatórios (S4). @since S4 */
import type {
  RelatorioInadimplentes, InadimplentesParams,
  RelatorioAdimplentes, AdimplentesParams,
  RelatorioPagamentosPorPolo, PagamentosPorPoloParams,
  RelatorioAcessoAva, AcessoAvaParams,
} from '@/domain/model/Relatorios';
import type { RelatorioGateway } from '@/application/port/out/RelatorioGateway';
import type {
  GetRelatorioInadimplentesUseCase, GetRelatorioAdimplentesUseCase,
  GetRelatorioPagamentosPorPoloUseCase, GetRelatorioAcessoAvaUseCase,
} from '@/application/port/in/RelatorioUseCase';

export class GetRelatorioInadimplentes implements GetRelatorioInadimplentesUseCase {
  constructor(private readonly g: RelatorioGateway) {}
  execute(params: InadimplentesParams): Promise<RelatorioInadimplentes> { return this.g.inadimplentes(params); }
}
export class GetRelatorioAdimplentes implements GetRelatorioAdimplentesUseCase {
  constructor(private readonly g: RelatorioGateway) {}
  execute(params: AdimplentesParams): Promise<RelatorioAdimplentes> { return this.g.adimplentes(params); }
}
export class GetRelatorioPagamentosPorPolo implements GetRelatorioPagamentosPorPoloUseCase {
  constructor(private readonly g: RelatorioGateway) {}
  execute(params: PagamentosPorPoloParams): Promise<RelatorioPagamentosPorPolo> { return this.g.pagamentosPorPolo(params); }
}
export class GetRelatorioAcessoAva implements GetRelatorioAcessoAvaUseCase {
  constructor(private readonly g: RelatorioGateway) {}
  execute(params: AcessoAvaParams): Promise<RelatorioAcessoAva> { return this.g.acessoAva(params); }
}
